import React from 'react';
import autoBind from 'react-autobind';
import Checkbox from 'material-ui/Checkbox';

export default class FieldCheck extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  handleChange(event) {
    const { name, value } = this.props;
    this.props.onChange({ name, value });
  }
  render() {
    const _props = { ...this.props };
    _props.onChange = this.handleChange;
    _props.onCheck = this.handleChange;
    return <Checkbox {..._props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldCheck/index.jsx